import { render, staticRenderFns } from "./ContainerWithNav.vue?vue&type=template&id=b94640fa&scoped=true"
import script from "./ContainerWithNav.vue?vue&type=script&lang=ts"
export * from "./ContainerWithNav.vue?vue&type=script&lang=ts"
import style0 from "./ContainerWithNav.vue?vue&type=style&index=0&id=b94640fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94640fa",
  null
  
)

export default component.exports